import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RaffleChevronRightIcon, RaffleHistoryIcon } from "./icons";
import cls from "./styles.module.scss";

export const RaffleHistoryButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={cls.historyButton}
      onClick={() => navigate("/apps/raffle/history")}
    >
      <span className={cls.historyButtonIcon}>
        <RaffleHistoryIcon />
      </span>
      <span className={cls.historyButtonLabel}>
        {t("raffle.history.button")}
      </span>
      <RaffleChevronRightIcon />
    </button>
  );
};
